module.exports = __webpack_public_path__ + "zxcg.png?b3fc31665e23174725258fbc3529be04";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zxcg.png
// module id = 619
// module chunks = 0